import { DEFAULT_LAYOUT } from '../base';
import type { AppRouteRecordRaw } from '../types';

const EXCEPTION: AppRouteRecordRaw = {
  path: '/exception',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '异常页',
    requiresAuth: true,
    icon: 'icon-exclamation-circle',
    // hideChildrenMenu: true,
    hideInMenu: true,
    order: 7
  },
  children: [
    {
      path: '403',
      name: '403',
      component: () => {
        return import('@/views/exception/403/page.vue');
      },
      meta: {
        locale: '403',
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '404',
      name: '404',
      component: () => {
        return import('@/views/exception/404/page.vue');
      },
      meta: {
        locale: '404',
        requiresAuth: true,
        roles: ['*']
      }
    },
    {
      path: '500',
      name: '500',
      component: () => {
        return import('@/views/exception/500/page.vue');
      },
      meta: {
        locale: '500',
        requiresAuth: true,
        roles: ['*']
      }
    }
  ]
};

export default EXCEPTION;
